const CalendarMainView = () => import('./views/CalendarMainView');
const CalendarView = () => import('./views/CalendarView');
const TaskView = () => import('./views/TaskView');
const ProjectsMainView = () => import('./views/ProjectsMainView');
const MyProjectsView = () => import('./views/MyProjectsView');
const CreateNewProjectView = () => import('./views/CreateNewProjectView');
const ProjectTasksView = () => import('./views/ProjectTasksView');
const TaskFormView = () => import('./views/TaskFormView');
const TaskDetailView = () => import('./views/TaskDetailView');

const routes = [
  {
    path: '/my-calendar',
    name: 'my-calendar',
    component: CalendarMainView,
    redirect: () => ({ name: 'calendar' }),
    children: [
      {
        path: '',
        name: 'calendar',
        component: CalendarView,
      },
      {
        path: 'new-task/:taskTypes/:calendarHour/:calendarDate',
        name: 'new-calendar-task',
        component: TaskFormView,
      },
      {
        path: 'task-detail/:taskId',
        name: 'calendar-task-detail',
        component: TaskDetailView,
      },
    ],
  },
  {
    path: '/tasks',
    name: 'task',
    component: TaskView,
  },
  {
    path: '/new-task',
    name: 'new-task',
    component: TaskFormView,
  },
  {
    path: '/edit-task/:taskId',
    name: 'edit-task',
    component: TaskFormView,
  },
  {
    path: '/task-detail/:taskId',
    name: 'task-detail',
    component: TaskDetailView,
  },
  {
    path: '/my-projects',
    name: 'projects-list',
    component: ProjectsMainView,
    redirect: () => ({ name: 'myProjects' }),
    children: [
      {
        path: '',
        name: 'myProjects',
        component: MyProjectsView,
      },
      {
        path: 'new-project',
        name: 'createNewProject',
        component: CreateNewProjectView,
      },
      {
        path: 'tasks/:projectId/:projectName',
        name: 'project-tasks',
        component: ProjectTasksView,
      },
      {
        path: 'new-task/:projectId/:projectName',
        name: 'new-project-task',
        component: TaskFormView,
      },
    ],
  },
];

export default (router) => {
  routes.forEach((element) => {
    router.addRoute('main', element);
  });
};

